/**
 * PolicyListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabContent,
  InputFormTable,
  Editor,
  Descriptions,
} from 'components';
import MessageAlert from 'utils';
import { Input, Button, Select, InputNumber, Radio, Flex, Alert } from 'antd';

/**----------------------------------------
 * [Component] 정책관리: 프레젠터
 * ----------------------------------------
 */
const PolicyListPresenter = ({
  userInfo,
  provisionData,
  onContentChange,
  onSave,
  onSaveSetting,
  onChange,
  setting,
  setSelectedKey,
  coupons,
  grades,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  // 권한 체크
  const canCreate = userInfo?.admin_privilege?.includes('C');
  const canUpdate = userInfo?.admin_privilege?.includes('U');
  const hasSavePermission = canCreate && canUpdate;

  /* ===== STATE ===== */

  /* ===== FUNCTION ===== */

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },

    couponLayout: {
      width: '100%',
      backgroundColor: '#f4f4f4',
      borderLeft: '20px solid #ddd',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 20,
      paddingLeft: 20,
      position: 'relative',
      top: 0,
      left: 0,
    },
    couponTitle: {
      fontSize: 18,
      fontWeight: 700,
      marginBottom: 16,
    },
    couponStatus: {
      color: 'var(--black-color)',
      fontSize: 16,
      lineHeight: 1.75,
    },
    couponDate: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--dark-gray-color)',
    },

    labelStyle: {
      // width: 155,
      width: '18%',
      color: '#111',
      fontWeight: '500',
      background: '#f4f4f4',
    },
    contentStyle: { width: '32%' },
    defaultStyle: {
      borderTop: '2px solid #d1d1d1',
      borderRadius: 5,
      marginTop: 5,
    },
  };
  //정기배송
  const subscriptionForm = [
    {
      label: '정기배송 정책',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 248, marginBottom: 15 }}
              value={setting?.parcel_service_setting?.policy}
              onChange={(e) =>
                onChange('parcel_service_setting', 'policy', e.target.value)
              }
              // showCount={true}
              fullScreen={true}
              // maxLength={500}
            />
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: '배송정지 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={[
                  { label: '배송 3일 전', value: 3 },
                  { label: '배송 5일 전', value: 5 },
                  { label: '배송 7일 전', value: 7 },
                  { label: '배송 10일 전', value: 10 },
                ]}
                value={setting?.parcel_service_setting?.stop_delivery_deadline}
                onChange={(e) =>
                  onChange(
                    'parcel_service_setting',
                    'stop_delivery_deadline',
                    e
                  )
                }
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 취소/미루기를 하지 않은 상품은 배송을 정지할 수 없습니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '정보변경 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={[
                  { label: '배송 3일 전', value: 3 },
                  { label: '배송 5일 전', value: 5 },
                  { label: '배송 7일 전', value: 7 },
                  { label: '배송 10일 전', value: 10 },
                ]}
                value={
                  setting?.parcel_service_setting?.change_delivery_deadline
                }
                onChange={(e) =>
                  onChange(
                    'parcel_service_setting',
                    'change_delivery_deadline',
                    e
                  )
                }
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 변경되지 않은 정보(결제, 주소, 결제일 등)는 당월 배송에
                반영되지 않습니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];
  //렌탈
  const rentalForm = [
    {
      label: '렌탈 정책',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 248, marginBottom: 15 }}
              value={setting?.rental_setting?.policy}
              onChange={(e) =>
                onChange('rental_setting', 'policy', e.target.value)
              }
              // showCount={true}
              fullScreen={true}
              // maxLength={500}
            />
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: '점검 기한 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={[
                  { label: '점검 1일 전', value: 1 },
                  { label: '점검 3일 전', value: 3 },
                  { label: '점검 5일 전', value: 5 },
                  { label: '점검 7일 전', value: 7 },
                  { label: '점검 10일 전', value: 10 },
                ]}
                value={setting?.rental_setting?.delay_inspection_deadline}
                onChange={(e) =>
                  onChange('rental_setting', 'delay_inspection_deadline', e)
                }
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 미루기를 하지 않은 점검은 정지할 수 없습니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '약정일 갱신 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={[
                  { label: '만료 3일 전', value: 3 },
                  { label: '만료 5일 전', value: 5 },
                  { label: '만료 7일 전', value: 7 },
                  { label: '만료 10일 전', value: 10 },
                ]}
                value={setting?.rental_setting?.renewal_agreement_deadline}
                onChange={(e) =>
                  onChange('rental_setting', 'renewal_agreement_deadline', e)
                }
              />
            </>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                까지 변경되지 않은 약정은 자동 갱신됩니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];
  //스탬프
  const stampForm = [
    {
      label: '안내 사항 설정',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="내용을 입력해주세요"
              style={{ height: 248, marginBottom: 15 }}
              value={setting?.stamp_setting?.guide}
              onChange={(e) =>
                onChange('stamp_setting', 'guide', e.target.value)
              }
              // showCount={true}
              fullScreen={true}
              // maxLength={500}
            />
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: '유효기간 설정 (일 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.stamp_setting?.expired_date}
              onChange={(e) => onChange('stamp_setting', 'expired_date', e)}
              maxLength={3}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>일</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                스탬프 적립일을 기준으로 유효기간이 측정됩니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '목표 갯수 설정 (음료 상품 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.stamp_setting?.goal_num}
              onChange={(e) => onChange('stamp_setting', 'goal_num', e)}
              maxLength={3}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>개</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                목표 갯수 시 쿠폰이 발급됩니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '목표 금액 설정 (디저트 상품 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.stamp_setting?.dessert_standard}
              onChange={(e) => onChange('stamp_setting', 'dessert_standard', e)}
              formatter={(value) =>
                value?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              } // 천단위 구분기호 추가
              parser={(value) => value?.replace(/,/g, '')} // 콤마 제거
              maxLength={8}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>원</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                목표 금액 달성 시 쿠폰이 발급됩니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '목표 금액 설정 (MD 상품 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.stamp_setting?.md_standard}
              onChange={(e) => onChange('stamp_setting', 'md_standard', e)}
              formatter={(value) =>
                value?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              } // 천단위 구분기호 추가
              parser={(value) => value?.replace(/,/g, '')} // 콤마 제거
              maxLength={8}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>원</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                목표 금액 달성 시 쿠폰이 발급됩니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={coupons?.map((v) => ({
                  label: v?.coupon_name,
                  value: v?.coupon_id,
                }))}
                value={setting?.stamp_setting?.coupon_id}
                onChange={(e) => onChange('stamp_setting', 'coupon_id', e)}
              />
            </>
          ),
        },
      ],
    },
  ];
  //포인트
  const pointForm = [
    {
      label: '유효기간 설정 (일 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.point_setting?.expired_date}
              onChange={(e) => onChange('point_setting', 'expired_date', e)}
              maxLength={3}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>일</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                포인트 발급일 기준으로 유효기간이 측정됩니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: (
        <span>
          포인트 사용 비율 설정
          <br />
          (최종 결제금 기준)
        </span>
      ),
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.point_setting?.point_usage_limit_ratio}
              onChange={(e) =>
                onChange('point_setting', 'point_usage_limit_ratio', e)
              }
              max={100}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>%</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                사용자가 실 결제하는 결제금을 기준으로 적용됩니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];
  //등급
  const gradeForm = [
    {
      label: '회원등급기준',
      form: [
        {
          input: (
            <Select
              options={[
                { label: '금액', value: 'AMOUNT' },
                { label: '주문건수', value: 'COUNT' },
                { label: '금액 그리고 주문건수', value: 'AMOUNT_AND_COUNT' },
                { label: '금액 또는 주문건수', value: 'AMOUNT_OR_COUNT' },
              ]}
              value={setting?.grade_setting?.grade_standard}
              onChange={(e) => onChange('grade_setting', 'grade_standard', e)}
            ></Select>
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                등급 산정의 기준을 정합니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>등급 기준 월</span>
          <span>(N개월의 금액, 또는 건수)</span>
        </div>
      ),
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.grade_setting?.total_month_standard}
              onChange={(e) =>
                onChange('grade_setting', 'total_month_standard', e)
              }
              formatter={(value) =>
                value?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              } // 천단위 구분기호 추가
              parser={(value) => value?.replace(/,/g, '')} // 콤마 제거
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                회원등급기준을 기준으로 N개월을 합산합니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '변경 일 (월 기준)',
      form: [
        {
          input: (
            <InputNumber
              placeholder="숫자만 입력"
              style={{ ...styles.form.input.large }}
              value={setting?.grade_setting?.date_of_change}
              onChange={(e) => onChange('grade_setting', 'date_of_change', e)}
              maxLength={3}
              min={0}
            />
          ),
        },
        {
          input: (
            <>
              <p style={{ ...styles.form.text }}>일</p>
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                적용 월 기준으로 등급이 적용됩니다. (기간이 지나면 다음 달부터
                적용됩니다.)
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '기본 등급 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={grades?.map((v) => ({
                  label: v?.grade_name,
                  value: v?.grade_id,
                }))}
                value={setting?.grade_setting?.grade_id}
                onChange={(e) => onChange('grade_setting', 'grade_id', e)}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '사업자 회원 등급 설정',
      form: [
        {
          input: (
            <>
              <Select
                options={grades?.map((v) => ({
                  label: v?.grade_name,
                  value: v?.grade_id,
                }))}
                value={setting?.grade_setting?.business_grade_id}
                onChange={(e) =>
                  onChange('grade_setting', 'business_grade_id', e)
                }
              />
            </>
          ),
        },
      ],
    },
  ];
  //앱
  const appForm = ['android', 'ios'].map((item) => ({
    label: `${item} 설정`,
    required: true,
    form: [
      {
        input: (
          <Descriptions
            bordered
            column={2}
            items={[
              {
                key: `1`,
                label: '최신 버전',
                children: (
                  <Input
                    placeholder="1.2.3"
                    value={setting?.app_setting?.[item]?.latestVersion || ''}
                    onChange={(e) => {
                      onChange(
                        'app_setting',
                        item,
                        e.target.value,
                        'latestVersion'
                      );
                    }}
                  />
                ),
                span: 2,
              },
              {
                key: `2`,
                label: '최소 업데이트 버전',
                children: (
                  <Flex gap={5} align="center">
                    <Input
                      style={{ width: '150px' }}
                      placeholder="1.2.3"
                      value={setting?.app_setting?.[item]?.minVersion || ''}
                      onChange={(e) => {
                        onChange(
                          'app_setting',
                          item,
                          e.target.value,
                          'minVersion'
                        );
                      }}
                    />
                    <p style={{ fontSize: '14px', color: '#D33444' }}>
                      * 필수로 업데이트 되어야하는 최소 버전입니다. 해당 버전
                      이하일 경우 앱이 정상 동작하지 않습니다.
                    </p>
                  </Flex>
                ),
                span: 2,
              },
              {
                key: `3`,
                label: '점검 여부',

                children: (
                  <Radio.Group
                    value={setting?.app_setting?.[item]?.isInspected || false}
                    onChange={(e) =>
                      onChange(
                        'app_setting',
                        item,
                        e.target.value,
                        'isInspected'
                      )
                    }
                  >
                    <Radio value={true}>점검</Radio>
                    <Radio value={false}>점검안함</Radio>
                  </Radio.Group>
                ),
                span: 2,
              },
              {
                key: `4`,
                label: '점검 메세지',
                style: { width: '100%' },
                children: (
                  <Input.TextArea
                    placeholder="1.2.3"
                    style={{ height: 248, marginBottom: 15 }}
                    value={setting?.app_setting?.[item]?.inspectedMessage || ''}
                    onChange={(e) => {
                      onChange(
                        'app_setting',
                        item,
                        e.target.value,
                        'inspectedMessage'
                      );
                    }}
                  />
                ),
              },
            ]}
          />
        ),
        fullscreen: true,
      },
    ],
  }));

  // [
  //   //
  //   {
  //     label: '안드로이드 설정',
  //     required: true,
  //     form: [
  //       {
  //         input: (
  //           <Descriptions
  //             bordered
  //             column={2}
  //             items={[
  //               {
  //                 key: `1`,
  //                 label: '최신 버전',
  //                 children: (
  //                   <Input
  //                     placeholder="1.2.3"
  //                     value={setting?.app_setting?.android?.latestVersion || ''}
  //                     onChange={(e) => {
  //                       onChange(
  //                         'app_setting',
  //                         'android',
  //                         e.target.value,
  //                         'latestVersion'
  //                       );
  //                     }}
  //                   />
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `2`,
  //                 label: '최소 업데이트 버전',
  //                 children: (
  //                   <Flex gap={5} align="center">
  //                     <Input
  //                       style={{ width: '150px' }}
  //                       placeholder="1.2.3"
  //                       value={setting?.app_setting?.android?.minVersion || ''}
  //                       onChange={(e) => {
  //                         onChange(
  //                           'app_setting',
  //                           'android',
  //                           e.target.value,
  //                           'minVersion'
  //                         );
  //                       }}
  //                     />
  //                     <p style={{ fontSize: '14px', color: '#D33444' }}>
  //                       * 필수로 업데이트 되어야하는 최소 버전입니다. 해당 버전
  //                       이하일 경우 앱이 실행되지 않습니다.
  //                     </p>
  //                   </Flex>
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `3`,
  //                 label: '점검 여부',

  //                 children: (
  //                   <Flex>
  //                     <Radio.Group
  //                       value={
  //                         setting?.app_setting?.android?.isInspected || false
  //                       }
  //                       onChange={(e) =>
  //                         onChange(
  //                           'app_setting',
  //                           'android',
  //                           e.target.value,
  //                           'isInspected'
  //                         )
  //                       }
  //                     >
  //                       <Radio value={true}>점검</Radio>
  //                       <Radio value={false}>점검안함</Radio>
  //                     </Radio.Group>
  //                     <p style={{ fontSize: '14px', color: '#D33444' }}>
  //                       * 점검 선택 후 저장 시 사용자가 앱을 종료 후 다시 실행할
  //                       경우에 반영됩니다.
  //                     </p>
  //                   </Flex>
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `4`,
  //                 label: '점검 메세지',
  //                 style: { width: '100%' },
  //                 children: (
  //                   <Input.TextArea
  //                     placeholder="1.2.3"
  //                     value={
  //                       setting?.app_setting?.android?.inspectedMessage || ''
  //                     }
  //                     onChange={(e) => {
  //                       onChange(
  //                         'app_setting',
  //                         'android',
  //                         e.target.value,
  //                         'inspectedMessage'
  //                       );
  //                     }}
  //                   />
  //                 ),
  //               },
  //             ]}
  //           />
  //         ),
  //         fullscreen: true,
  //       },
  //     ],
  //   },
  //   //
  //   {
  //     label: '아이폰 설정',
  //     required: true,
  //     form: [
  //       {
  //         input: (
  //           <Descriptions
  //             bordered
  //             column={2}
  //             items={[
  //               {
  //                 key: `1`,
  //                 label: '최신 버전',
  //                 children: (
  //                   <Flex gap={5} align="center">
  //                     <Input
  //                       placeholder="1.2.3"
  //                       value={setting?.app_setting?.ios?.latestVersion || ''}
  //                       onChange={(e) => {
  //                         onChange(
  //                           'app_setting',
  //                           'ios',
  //                           e.target.value,
  //                           'latestVersion'
  //                         );
  //                       }}
  //                     />
  //                     <p style={{ fontSize: '14px', color: '#D33444' }}>
  //                       * 필수로 업데이트 되어야하는 최소 버전입니다. 해당 버전
  //                       이하일 경우 앱이 실행되지 않습니다.
  //                     </p>
  //                   </Flex>
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `2`,
  //                 label: '최소 업데이트 버전',
  //                 children: (
  //                   <Input
  //                     placeholder="1.2.3"
  //                     value={setting?.app_setting?.ios?.minVersion || ''}
  //                     onChange={(e) => {
  //                       onChange(
  //                         'app_setting',
  //                         'ios',
  //                         e.target.value,
  //                         'minVersion'
  //                       );
  //                     }}
  //                   />
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `3`,
  //                 label: '점검 여부',

  //                 children: (
  //                   <Radio.Group
  //                     value={setting?.app_setting?.ios?.isInspected || false}
  //                     onChange={(e) =>
  //                       onChange(
  //                         'app_setting',
  //                         'ios',
  //                         e.target.value,
  //                         'isInspected'
  //                       )
  //                     }
  //                   >
  //                     <Radio value={true}>점검</Radio>
  //                     <Radio value={false}>점검안함</Radio>
  //                   </Radio.Group>
  //                 ),
  //                 span: 2,
  //               },
  //               {
  //                 key: `4`,
  //                 label: '점검 메세지',
  //                 style: { width: '100%' },
  //                 children: (
  //                   <Input.TextArea
  //                     placeholder="1.2.3"
  //                     value={setting?.app_setting?.ios?.inspectedMessage || ''}
  //                     onChange={(e) => {
  //                       onChange(
  //                         'app_setting',
  //                         'ios',
  //                         e.target.value,
  //                         'inspectedMessage'
  //                       );
  //                     }}
  //                   />
  //                 ),
  //               },
  //             ]}
  //           />
  //         ),
  //         fullscreen: true,
  //       },
  //     ],
  //   },
  //   //
  // ];
  //결제
  const paymentForm = [
    {
      label: '할부 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                placeholder="예: 0:1:2:3:4:5"
                value={setting?.payment_setting?.installment_setting || ''}
                onChange={(e) => {
                  onChange(
                    'payment_setting',
                    'installment_setting',
                    e.target.value
                  );
                }}
              />
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                할부 개월 수를 콜론(:)으로 구분하여 입력해 주세요. 예: 0:1:2:3
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '무이자 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                placeholder="예: NONE 또는 3:4:5"
                value={setting?.payment_setting?.non_interest_setting || ''}
                onChange={(e) => {
                  onChange(
                    'payment_setting',
                    'non_interest_setting',
                    e.target.value
                  );
                }}
              />
              <p style={{ fontStyle: 12, fontWEight: 400, color: '#8F8F8F' }}>
                무이자 기간을 콜론(:)으로 구분하여 입력해 주세요. 예: 3:4:5
                <br />
                'NONE'을 입력하면 무이자 없음으로 설정됩니다.
              </p>
            </>
          ),
        },
      ],
    },
  ];

  // 이용약관 관련 수정
  // 기본 약관 항목 정의
  const defaultProvisions = [
    { provision_type: 'PRIVACY', provision_title: '개인정보 처리방침' },
    { provision_type: 'USE', provision_title: '서비스 이용약관' },
    { provision_type: 'REFUND', provision_title: '환불 약관' },
    { provision_type: 'PRESENT', provision_title: '선물하기 정책' },
    { provision_type: 'CHARGE', provision_title: '충전식 상품권 약관' },
    { provision_type: 'LOCATION', provision_title: '위치정보 약관' },
  ];

  // 기본 약관 항목과 실제 데이터를 병합
  const mergedData = defaultProvisions?.map((defaultItem) => {
    const existingItem = provisionData?.find(
      (item) => item.provision_type === defaultItem.provision_type
    );
    return {
      provision_id: existingItem?.provision_id || null,
      provision_type: defaultItem.provision_type,
      provision_title: defaultItem.provision_title,
      provision_content: existingItem?.provision_content || '',
    };
  });
  // InputFormTable에 전달할 form 데이터 생성
  const formItems = mergedData.map((item) => ({
    label: item.provision_title,
    required: true,
    form: [
      {
        input: (
          <Editor
            height={300}
            initialContent={item.provision_content}
            editorOnChange={(content) =>
              onContentChange(item.provision_type, content)
            }
            style={{ width: '100%', height: 98 }}
          />
        ),
        fullscreen: true,
        // count: true,
        // maxLength: 1000,
      },
    ],
  }));

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log(hasSavePermission);
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 10 }}>
            정책 관리
          </Title>

          {/* 정책목록 */}
          <Content
            maxWidth={'100%'}
            padding={'20px 16px'}
            className="boxShadow"
          >
            <TabContent
              onChange={(val) => setSelectedKey(val.key)}
              items={[
                {
                  label: `정기배송 정책 관리`,
                  key: `parcel_service_setting`,
                  children: (
                    <div>
                      <InputFormTable form={subscriptionForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('수정 권한이 없습니다')
                          }
                        >
                          저장
                        </Button>{' '}
                        {/* <Button type="default">초기화</Button> */}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `렌탈 정책 관리`,
                  key: `rental_setting`,
                  children: (
                    <div>
                      <InputFormTable form={rentalForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('수정 권한이 없습니다')
                          }
                        >
                          저장
                        </Button>{' '}
                        {/* <Button type="default">초기화</Button> */}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `이용약관 관리`,
                  key: `provision`,
                  children: (
                    <div>
                      <InputFormTable form={formItems} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSave()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `스탬프 관리`,
                  key: `stamp_setting`,
                  children: (
                    <div>
                      <InputFormTable form={stampForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `포인트 관리`,
                  key: `point_setting`,
                  children: (
                    <div>
                      <InputFormTable form={pointForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `등급 관리`,
                  key: `grade_setting`,
                  children: (
                    <div>
                      <InputFormTable form={gradeForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `결제 관리`,
                  key: `payment_setting`,
                  children: (
                    <div>
                      <InputFormTable form={paymentForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
                {
                  label: `앱 관리`,
                  key: `app_setting`,
                  children: (
                    <div>
                      <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: 14 }}
                        message={<h4>주의!</h4>}
                        description={
                          <p>
                            아래 설정은 사용자가 앱을 종료 후 다시 실행할 경우에
                            적용됩니다.
                            <br />
                            이미 앱을 사용중일 때에는 변경된 설정이 적용되지
                            않습니다.
                          </p>
                        }
                      />
                      <InputFormTable form={appForm} />
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 14,
                        }}
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hasSavePermission
                              ? onSaveSetting()
                              : MessageAlert.warning('권한이 없습니다.')
                          }
                        >
                          저장
                        </Button>{' '}
                      </div>
                    </div>
                  ),
                },
              ]}
            />
          </Content>
          {/* 정책목록 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PolicyListPresenter;
